import { generateYearList } from "ui/Date";

import { VesselAuction } from "interface/vessel";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { AuctionObligationVesselsRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { useUserStore } from "store";
import { UserRole } from "interface/user";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { COLOR } from "utils/constant";
import { AuctionFilter } from "api/sales";
import { getAuctionVesselNO, getAuctionVesselByName } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: AuctionFilter) => void;
	filterOptions: AuctionFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const { roles } = useUserStore();

	const handleVessel = (vessel: VesselAuction) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.vesselId as any,
			vesselName: vessel.vesselName,
			vesselRegistrationNumber: vessel.vesselRegistrationId,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items auctioned-weight-filter-items">
				<div className="auctioned-weight-filter-field">
					<DropDownList
						data={generateYearList(2022)}
						filterable={false}
						label={t("Year")}
						value={filterOptions.quotaYear}
						onChange={(e) => {
							setFilterOptions({
								...filterOptions,
								quotaYear: e.target.value as number,
							});
						}}
						defaultValue={filterOptions.quotaYear}
						// defaultItem={new Date().getFullYear()}
						popupSettings={{ width: 400 }}
						style={{
							backgroundColor: COLOR.Grey98,
							// borderWidth: "1px",
							width: "100%",
						}}
					/>
				</div>
				{roles.includes(UserRole.Admin) && (
					<div className="auctioned-weight-filter-field">
						<CustomDropDownList
							data={[]}
							filterable={true}
							dataItemKey="vesselId"
							textField="vesselRegistrationId"
							label={t("VesselRegistrationNo")}
							itemRender={AuctionObligationVesselsRenderItem}
							value={{
								vesselId: filterOptions.vesselId || null,
								vesselRegistrationId:
							//		filterOptions.vesselRegistrationNumber || t("ChooseVessel"),
									filterOptions.vesselRegistrationNumber || " ",
							}}
							// label="Velg Fartøy"
							// defaultItem={{ id: null, nm: t("All") }}
							onSelect={handleVessel}
							serverFilter={true}
							serverFilterApi={getAuctionVesselNO}
						/>
					</div>
				)}
				{roles.includes(UserRole.Admin) && (
					<div className="auctioned-weight-filter-field">
						<CustomDropDownList
							data={[]}
							filterable={true}
							dataItemKey="vesselId"
							textField="vesselName"
							label={t("VesselNameAndId")}
							itemRender={AuctionObligationVesselsRenderItem}
							value={{
								vesselId: filterOptions.vesselId || null,
							//	vesselName: filterOptions.vesselName || t("ChooseVessel"),
								vesselName: filterOptions.vesselName || " ",
							}}
							// label="Velg Fartøy"
							// defaultItem={{ id: null, nm: t("All") }}
							onSelect={handleVessel}
							serverFilter={true}
							serverFilterApi={getAuctionVesselByName}
							// popupSettings={{ width: 400 }}
						/>
					</div>
				)}
			</div>
			{/* 
			<div className="filter-end-btn">
				<CustomButton
					label={"PDF"}
					onClick={() => exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div> */}
		</div>
	);
};

export default Filter;
